import React from 'react';
import BaseHeader from "./BaseHeader";

export default function DefaultHeader(props) {

    return <BaseHeader
        header={props.title}
        location={null}
        isMobile={props.isMobile}
        exitUrl={null}
        handleItemExit={null}
        path={[
            {url: props.url, label: props.title}
        ]}
    />;
}


